import {
  Component,
  Inject,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef
} from '@angular/core';
import { DialogPosition, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IDetailsPopupData } from './details-popup.interfaces';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'details-popup',
  templateUrl: './details-popup.component.html',
  styleUrls: ['./details-popup.component.scss']
})
export class DetailsPopupComponent implements OnInit, AfterViewInit {
  dialogPosition: DialogPosition;
  @ViewChild('detailsMenu') detailsMenu: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDetailsPopupData,
    public dialogRef: MatDialogRef<DetailsPopupComponent>,
    @Inject(DOCUMENT) private document: any
  ) {}

  ngOnInit() {
    this.setSize();
    this.setPosition();
  }

  ngAfterViewInit() {
    // ensure that the dialog does not break the screen boundaries
    this.updatePosition();
  }

  // sets the initial position relative to the anchor element
  setPosition() {
    const dialogPosition: DialogPosition = {};
    const rect = this.data.anchorElement.nativeElement.getBoundingClientRect();
    const origin = {
      x: rect.x,
      y: rect.y
    };

    switch (this.data.anchorOrigin.horizontal) {
      case 'left':
        // do nothing
        break;
      case 'right':
        origin.x += rect.width;
        break;
      default:
        // center
        origin.x += rect.width / 2;
        break;
    }

    switch (this.data.anchorOrigin.vertical) {
      case 'top':
        // do nothing
        break;
      case 'bottom':
        origin.y += rect.height;
        break;
      default:
        // center
        origin.y += rect.height / 2;
        break;
    }

    switch (this.data.transformOrigin.vertical) {
      case 'top':
        dialogPosition.top = `${origin.y}px`;
        break;
      case 'bottom':
        dialogPosition.bottom = `${origin.y}px`;
        break;
      default:
        // center
        dialogPosition.top = `${origin.y - rect.height / 2}px`;
        break;
    }

    switch (this.data.transformOrigin.horizontal) {
      case 'left':
        dialogPosition.left = `${origin.x}px`;
        break;
      case 'right':
        dialogPosition.right = `${this.document.body.clientWidth - origin.x}px`;
        break;
      default:
        // center
        dialogPosition.left = `${origin.x - rect.width / 2}px`;
        break;
    }

    // save the position
    this.dialogPosition = dialogPosition;

    this.dialogRef.updatePosition(dialogPosition);
  }

  setSize() {
    if (this.data.size) {
      this.dialogRef.updateSize(this.data.size.width, this.data.size.height);
    }
  }

  updatePosition() {
    const dialogPosition: DialogPosition = { ...this.dialogPosition };
    const rect = this.detailsMenu.nativeElement.getBoundingClientRect();
    const bottomOverflow = rect.y + rect.height - this.document.body.clientHeight;

    if (dialogPosition.top && bottomOverflow > 0) {
      dialogPosition.top = `${parseInt(dialogPosition.top, 10) -
        bottomOverflow}px`;
    }

    this.dialogRef.updatePosition(dialogPosition);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
